module.exports = __webpack_public_path__ + "img/profile.30da63e6.png";